import { Component } from '@angular/core';
import { MedrecordIcon } from '../../base/medrecord-icon';

@Component({
  selector: 'medrecord-svg-check',
  templateUrl: './check.component.svg',
  styleUrls: ['./check.component.scss'],
})
export class CheckComponent extends MedrecordIcon {
  viewHeight = 16;
  viewWidth = 16;
}
